import React from 'react'

export interface IProps {
}

const DevPage: React.FC<IProps> = ({}) => {
    return <div>Dev Page</div>
}

export default DevPage